import { useEffect, useRef, useState } from "react";
import API from "../services/api";
import { createJob } from "../services/jobService";
import { useNavigate } from "react-router-dom";

/* ─────────────────────────── SVG Icons ─────────────────────────── */
const EditIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 14, height: 14 }}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const TrashIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 14, height: 14 }}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const ImageIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 30, height: 30 }}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);

const ExportIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 14, height: 14 }}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <line x1="9" y1="15" x2="12" y2="12" />
    <line x1="15" y1="15" x2="12" y2="12" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 13, height: 13 }}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const AlertIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 16, height: 16, flexShrink: 0, marginTop: 1 }}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const SpinnerIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" style={{ width: 15, height: 15, animation: "spin 0.8s linear infinite" }}>
    <path d="M12 2a10 10 0 0 1 10 10" />
  </svg>
);

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 14, height: 14 }}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 10, height: 10 }}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

/* ─────────────────────────── Styles ─────────────────────────────── */
const STYLES = `
  @keyframes spin { to { transform: rotate(360deg); } }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    background: #f1f3f6;
    color: #111827;
    font-size: 14px;
  }

  .page-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1.5rem 1.25rem 5rem;
  }

  .bc {
    display: flex; align-items: center; gap: .35rem;
    font-size: .82rem; color: #6b7280; margin-bottom: 1rem;
  }
  .bc a { color: #2563eb; font-weight: 600; cursor: pointer; text-decoration: none; }
  .bc span { color: #9ca3af; }

  .vbanner {
    display: flex; align-items: flex-start; gap: .6rem;
    background: #fff5f5; border: 1.5px solid #fecaca;
    border-radius: 10px; padding: .75rem 1rem;
    font-size: .8rem; color: #374151; margin-bottom: 1.25rem; line-height: 1.55;
  }
  .vbanner strong { color: #dc2626; font-weight: 700; }

  .success-banner {
    display: flex; align-items: center; gap: .6rem;
    background: #f0fdf4; border: 1.5px solid #86efac;
    border-radius: 10px; padding: .75rem 1rem;
    font-size: .85rem; color: #15803d; margin-bottom: 1.25rem;
    font-weight: 600; animation: fadeIn .3s ease;
  }

  .error-banner {
    background: #fff5f5; border: 1.5px solid #fecaca;
    border-radius: 10px; padding: .75rem 1rem;
    margin-bottom: 1.25rem; animation: fadeIn .3s ease;
  }
  .error-banner .err-title {
    display: flex; align-items: center; gap: .5rem;
    font-size: .85rem; font-weight: 700; color: #dc2626; margin-bottom: .4rem;
  }
  .error-banner ul {
    padding-left: 1.2rem; font-size: .8rem; color: #374151; line-height: 1.7;
  }

  .loader-overlay {
    position: fixed; inset: 0; z-index: 9999;
    background: rgba(17,24,39,.45);
    display: flex; align-items: center; justify-content: center;
    backdrop-filter: blur(2px);
  }
  .loader-box {
    background: #fff; border-radius: 16px;
    padding: 2rem 2.5rem;
    display: flex; flex-direction: column; align-items: center; gap: 1rem;
    box-shadow: 0 20px 60px rgba(0,0,0,.2);
    animation: slideUp .25s ease;
    min-width: 220px; text-align: center;
  }
  .loader-spinner {
    width: 44px; height: 44px;
    border: 3.5px solid #e5e7eb;
    border-top-color: #2563eb;
    border-radius: 50%;
    animation: spin .7s linear infinite;
  }
  .loader-title { font-size: .95rem; font-weight: 700; color: #111827; }
  .loader-sub { font-size: .78rem; color: #9ca3af; }

  .two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    align-items: start;
  }

  .card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    overflow: hidden;
  }

  .card-hd {
    padding: .9rem 1.2rem;
    border-bottom: 1px solid #f0f2f5;
    display: flex; justify-content: space-between; align-items: center;
  }
  .card-hd h3 { font-size: .95rem; font-weight: 700; color: #111827; }
  .card-hd .sub { font-size: .72rem; color: #9ca3af; margin-top: 2px; }

  .card-body { padding: 1.1rem 1.2rem; }

  .fg { display: flex; flex-direction: column; gap: .3rem; margin-bottom: .85rem; }
  .fg:last-child { margin-bottom: 0; }

  .fl {
    font-size: .68rem; font-weight: 700;
    letter-spacing: .07em; text-transform: uppercase; color: #374151;
  }
  .fl.req::after { content: " *"; color: #dc2626; }

  .fi, .fs {
    width: 100%; padding: .62rem .8rem;
    border: 1.5px solid #e5e7eb; border-radius: 9px;
    font-size: .875rem; font-family: inherit; color: #111827;
    background: #fff; outline: none;
    transition: border-color .15s, box-shadow .15s;
    -webkit-appearance: none; appearance: none;
  }
  .fi::placeholder { color: #c0c4cc; }
  .fi:focus, .fs:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99,102,241,.1);
  }
  .fi:disabled, .fs:disabled {
    background: #f9fafb; color: #6b7280; cursor: not-allowed;
  }

  .fi.field-err, .fs.field-err {
    border-color: #f87171;
    box-shadow: 0 0 0 3px rgba(239,68,68,.08);
  }
  .field-err-msg {
    font-size: .7rem; color: #dc2626; margin-top: 2px; font-weight: 500;
  }

  .fs {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right .8rem center;
    padding-right: 2.2rem;
    cursor: pointer;
  }
  .fs:disabled {
    background-image: none;
    cursor: not-allowed;
  }

  /* textarea shares fi styles but is resizable */
  .fi-textarea {
    resize: vertical;
    min-height: 68px;
    line-height: 1.5;
    font-family: inherit;
  }

  .form-help { font-size: .7rem; color: #9ca3af; margin-top: 2px; }

  .form-row {
    display: grid; grid-template-columns: 1fr 1fr;
    gap: .75rem; margin-bottom: .85rem;
  }

  .status-hint {
    font-size: .75rem; color: #9ca3af; margin-top: .35rem; line-height: 1.5;
  }
  .status-hint strong { color: #374151; }

  /* ── Multi-select Staff Picker ── */
  .staff-picker {
    border: 1.5px solid #e5e7eb; border-radius: 9px;
    background: #fff; overflow: hidden;
    transition: border-color .15s, box-shadow .15s;
  }
  .staff-picker:focus-within {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99,102,241,.1);
  }
  .staff-picker.field-err { border-color: #f87171; box-shadow: 0 0 0 3px rgba(239,68,68,.08); }

  .staff-tags {
    display: flex; flex-wrap: wrap; gap: .35rem;
    padding: .5rem .7rem;
    min-height: 42px; align-items: center;
  }
  .staff-tag {
    display: inline-flex; align-items: center; gap: .3rem;
    background: #eff6ff; border: 1px solid #bfdbfe;
    border-radius: 6px; padding: 3px 8px;
    font-size: .75rem; font-weight: 600; color: #1d4ed8;
    animation: fadeIn .15s ease;
  }
  .staff-tag button {
    background: none; border: none; cursor: pointer;
    color: #6b7280; padding: 0; display: flex; align-items: center;
    transition: color .1s;
  }
  .staff-tag button:hover { color: #dc2626; }

  .staff-picker-select {
    width: 100%; padding: .45rem .8rem;
    border: none; border-top: 1px solid #f0f2f5;
    font-size: .82rem; font-family: inherit; color: #374151;
    background: #f9fafb; outline: none; cursor: pointer;
    -webkit-appearance: none; appearance: none;
  }
  .staff-picker-select:disabled { cursor: not-allowed; color: #9ca3af; }

  /* ── Locked staff display (staff role) ── */
  .staff-locked {
    display: flex; align-items: center; gap: .5rem;
    padding: .62rem .8rem; background: #f9fafb;
    border: 1.5px solid #e5e7eb; border-radius: 9px;
    font-size: .875rem; color: #374151;
  }
  .staff-locked-badge {
    background: #dcfce7; color: #15803d;
    font-size: .65rem; font-weight: 700; letter-spacing: .06em;
    padding: 2px 8px; border-radius: 999px; text-transform: uppercase;
  }

  .act-entry {
    display: flex; justify-content: space-between; align-items: center;
    background: #f9fafb; border: 1.5px solid #e5e7eb;
    border-radius: 10px; padding: .65rem .9rem; margin-bottom: .5rem;
    animation: fadeIn .2s ease;
  }
  .act-name { font-size: .82rem; font-weight: 600; color: #111827; margin-bottom: 2px; }
  .act-meta { font-size: .72rem; color: #9ca3af; }
  .act-right { display: flex; align-items: center; gap: .45rem; }

  .badge-min {
    background: #dcfce7; color: #15803d;
    padding: 3px 11px; border-radius: 999px;
    font-size: .7rem; font-weight: 700; white-space: nowrap;
  }

  .btn-icon {
    width: 34px; height: 34px; border-radius: 8px;
    border: 1.5px solid #e5e7eb; background: #fff;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; padding: 0; color: #374151;
    transition: background .12s; flex-shrink: 0;
  }
  .btn-icon:hover { background: #f3f4f6; }
  .btn-icon.del { border-color: #fecaca; color: #dc2626; }
  .btn-icon.del:hover { background: #fef2f2; }

  .btn-outline-sm {
    display: inline-flex; align-items: center; gap: .3rem;
    padding: .45rem .95rem;
    border: 1.5px solid #d1d5db; border-radius: 9px;
    background: #fff; font-size: .8rem; font-weight: 600;
    font-family: inherit; color: #374151; cursor: pointer;
    transition: background .12s, border-color .12s; margin-top: .5rem;
  }
  .btn-outline-sm:hover { background: #f9fafb; border-color: #9ca3af; }

  /* ── Unit badge pill (inside material row) ── */
  .unit-badge {
    display: inline-flex; align-items: center; justify-content: center;
    background: #f0fdf4; color: #15803d;
    border: 1px solid #bbf7d0;
    padding: 2px 9px; border-radius: 20px;
    font-size: .68rem; font-weight: 700; letter-spacing: .04em;
    white-space: nowrap;
  }

  .photo-tabs { display: flex; gap: .45rem; margin-bottom: 1rem; }
  .photo-tab {
    padding: 6px 16px; border-radius: 999px;
    border: 1.5px solid #d1d5db; background: #fff;
    color: #374151; font-size: .8rem; font-weight: 600;
    font-family: inherit; cursor: pointer; transition: all .15s;
  }
  .photo-tab.active { background: #2563eb; border-color: #2563eb; color: #fff; }

  .photo-counter {
    font-size: .75rem; font-weight: 600; color: #6b7280;
    background: #f3f4f6; border: 1px solid #e5e7eb;
    border-radius: 999px; padding: 2px 10px;
  }

  .drop-zone {
    border: 2px dashed #bfdbfe; border-radius: 12px;
    background: #f0f6ff; padding: 2rem 1rem;
    display: flex; flex-direction: column;
    align-items: center; gap: .4rem; cursor: pointer;
    transition: background .15s, border-color .15s;
  }
  .drop-zone:hover { background: #e0eeff; border-color: #93c5fd; }
  .drop-zone-title { font-size: .9rem; font-weight: 700; color: #1e3a8a; }
  .drop-zone-sub { font-size: .72rem; color: #9ca3af; }

  .photo-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
    gap: .5rem; margin-bottom: .85rem;
  }
  .photo-thumb {
    position: relative; border-radius: 8px; overflow: hidden;
    aspect-ratio: 1; border: 1px solid #e5e7eb;
  }
  .photo-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .photo-remove {
    position: absolute; top: 3px; right: 3px;
    width: 18px; height: 18px; border-radius: 50%;
    background: rgba(0,0,0,.55); border: none;
    color: #fff; font-size: .6rem;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; padding: 0; line-height: 1;
  }

  .divider { border: none; border-top: 1px solid #f0f2f5; margin: .85rem 0; }

  .form-footer {
    display: flex; justify-content: space-between; align-items: center;
    padding: 1rem 0; margin-top: .75rem; border-top: 1px solid #e5e7eb;
  }

  .btn-ghost {
    padding: .55rem 1.2rem;
    border: 1.5px solid #d1d5db; border-radius: 9px;
    background: #fff; font-size: .875rem; font-weight: 600;
    font-family: inherit; color: #374151; cursor: pointer;
    transition: background .12s;
  }
  .btn-ghost:hover { background: #f9fafb; }
  .btn-ghost:disabled { opacity: .5; cursor: not-allowed; }

  .btn-export {
    display: inline-flex; align-items: center; gap: .4rem;
    padding: .55rem 1.1rem;
    border: 1.5px solid #d1d5db; border-radius: 9px;
    background: #fff; font-size: .875rem; font-weight: 600;
    font-family: inherit; color: #374151; cursor: pointer;
    transition: background .12s;
  }
  .btn-export:hover { background: #f9fafb; }

  .btn-submit {
    display: inline-flex; align-items: center; gap: .4rem;
    padding: .55rem 1.25rem; border: none; border-radius: 9px;
    background: #2563eb; font-size: .875rem; font-weight: 700;
    font-family: inherit; color: #fff; cursor: pointer;
    transition: background .12s;
  }
  .btn-submit:hover:not(:disabled) { background: #1d4ed8; }
  .btn-submit:disabled { background: #93c5fd; cursor: not-allowed; }

  /* ── Info hint chip ── */
  .role-hint {
    display: inline-flex; align-items: center; gap: .35rem;
    background: #f0f9ff; border: 1px solid #bae6fd;
    border-radius: 6px; padding: 4px 10px;
    font-size: .7rem; color: #0369a1; font-weight: 600;
    margin-top: .4rem;
  }

  @media (max-width: 720px) { .two-col { grid-template-columns: 1fr; } }
`;

const MATERIAL_OPTIONS = [
  "Vinyl Wrap Rolls", "Paint", "LVT / SPC Flooring", "Carpet Roll",
  "Epoxy Resin", "Micro-Cement", "Stone Veneer", "ACP Sheet",
  "Décor Panel", "Adhesive / Primer", "Masking Tape", "Grout / Sealant",
];

/* NEW: unit options matching JobDetailsForm */
const UNIT_OPTIONS = ["nos", "mtr", "box"];

const PHOTO_TABS = ["Before Work", "During Work", "After Work"];
const MAX_PHOTOS = 10;

/* ── Helpers ── */
const calcDuration = (s, e) =>
  (new Date(`1970-01-01T${e}`) - new Date(`1970-01-01T${s}`)) / 60000;

/* ── Get logged-in user info ── */
const getLoggedUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
};

/* ─────────────────────────── Component ─────────────────────────── */
function CreateJobForm() {
  const navigate = useNavigate();

  const loggedUser = getLoggedUser();
  const loggedRole = loggedUser?.role?.toLowerCase() || "";
  const isStaff = loggedRole === "staff";

  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [serverErrors, setServerErrors] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});

  /* ── Staff list (for admin/supervisor) ── */
  const [staffList, setStaffList] = useState([]);

  useEffect(() => {
    if (!isStaff) {
      API.get("/users/staff-supervisors")
        .then((res) => { if (res.data.success) setStaffList(res.data.data); })
        .catch((err) => console.log("Error:", err));
    }
  }, [isStaff]);

  /* ── Multi-select staff IDs ── */
  const [selectedStaffIds, setSelectedStaffIds] = useState(
    isStaff && loggedUser?.id ? [String(loggedUser.id)] : []
  );

  const handleAddStaff = (e) => {
    const val = e.target.value;
    if (!val || selectedStaffIds.includes(val)) return;
    setSelectedStaffIds((prev) => [...prev, val]);
    setFieldErrors((p) => ({ ...p, staff_id: "" }));
    e.target.value = "";
  };

  const handleRemoveStaff = (id) =>
    setSelectedStaffIds((prev) => prev.filter((s) => s !== id));

  const getStaffNameById = (id) => {
    if (isStaff && String(loggedUser?.id) === String(id)) return loggedUser?.name || "You";
    const u = staffList.find((u) => String(u.id) === String(id));
    return u ? u.name : `Staff #${id}`;
  };

  const assignableUsers = isStaff
    ? (loggedUser ? [{ id: loggedUser.id, name: loggedUser.name }] : [])
    : staffList.filter((s) => selectedStaffIds.includes(String(s.id)));

  /* ── Basic Fields — address added ── */
  const [clientName, setClientName] = useState("");
  const [location,   setLocation]   = useState("");
  const [address,    setAddress]    = useState("");   /* NEW */
  const [workType,   setWorkType]   = useState("");
  const [jobStatus,  setJobStatus]  = useState("ongoing");

  /* ── Activity Logs ── */
  const [activities,    setActivities]    = useState([]);
  const [activityType,  setActivityType]  = useState("");
  const [activityUserId,setActivityUserId]= useState(
    isStaff && loggedUser?.id ? String(loggedUser.id) : ""
  );
  const [startTime,  setStartTime]  = useState("");
  const [endTime,    setEndTime]    = useState("");
  const [editIndex,  setEditIndex]  = useState(null);
  const [activityError, setActivityError] = useState("");

  useEffect(() => {
    if (!isStaff && selectedStaffIds.length === 1) {
      setActivityUserId(selectedStaffIds[0]);
    } else if (!isStaff && selectedStaffIds.length === 0) {
      setActivityUserId("");
    }
  }, [selectedStaffIds, isStaff]);

  const handleAddActivity = () => {
    if (!activityType || !startTime || !endTime) {
      setActivityError("Please fill all activity fields.");
      return;
    }
    const dur = calcDuration(startTime, endTime);
    if (dur <= 0) { setActivityError("End time must be after start time."); return; }
    setActivityError("");

    const entry = {
      type: activityType,
      userId: activityUserId || (selectedStaffIds[0] ?? ""),
      start: startTime,
      end: endTime,
    };
    if (editIndex !== null) {
      const updated = [...activities];
      updated[editIndex] = entry;
      setActivities(updated);
      setEditIndex(null);
    } else {
      setActivities([...activities, entry]);
    }
    setActivityType("");
    setStartTime("");
    setEndTime("");
    if (!isStaff) setActivityUserId(selectedStaffIds.length === 1 ? selectedStaffIds[0] : "");
  };

  const handleEditActivity = (i) => {
    const a = activities[i];
    setActivityType(a.type);
    setActivityUserId(a.userId);
    setStartTime(a.start);
    setEndTime(a.end);
    setEditIndex(i);
    setActivityError("");
  };

  const handleDeleteActivity = (i) => {
    setActivities(activities.filter((_, idx) => idx !== i));
    if (editIndex === i) {
      setActivityType(""); setStartTime(""); setEndTime(""); setEditIndex(null);
    }
  };

  /* ── Materials — unit field added ── */
  const [materials, setMaterials] = useState([
    {
      id: 1,
      name: "Vinyl Wrap Rolls",
      qty: 1,
      unit: "nos",                                          /* NEW */
      userId: isStaff && loggedUser?.id ? String(loggedUser.id) : "",
    },
  ]);

  const handleAddMaterial = () =>
    setMaterials([...materials, {
      id: Date.now(),
      name: MATERIAL_OPTIONS[0],
      qty: 1,
      unit: "nos",                                          /* NEW */
      userId: isStaff && loggedUser?.id
        ? String(loggedUser.id)
        : (selectedStaffIds.length === 1 ? selectedStaffIds[0] : ""),
    }]);

  const handleMaterialChange = (id, field, value) =>
    setMaterials(materials.map((m) => (m.id === id ? { ...m, [field]: value } : m)));

  const handleDeleteMaterial = (id) =>
    setMaterials(materials.filter((m) => m.id !== id));

  /* ── Photos ── */
  const [activeTab,   setActiveTab]   = useState("Before Work");
  const [photos,      setPhotos]      = useState({ "Before Work": [], "During Work": [], "After Work": [] });
  const [photoFiles,  setPhotoFiles]  = useState({ "Before Work": [], "During Work": [], "After Work": [] });
  const fileInputRef = useRef(null);

  const currentPhotos = photos[activeTab] || [];

  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    const remaining = MAX_PHOTOS - currentPhotos.length;
    const sliced = files.slice(0, remaining);
    const newPreviews = sliced.map((f) => ({
      id: Date.now() + Math.random(),
      url: URL.createObjectURL(f),
      name: f.name,
    }));
    setPhotos((prev) => ({ ...prev, [activeTab]: [...prev[activeTab], ...newPreviews] }));
    setPhotoFiles((prev) => ({ ...prev, [activeTab]: [...prev[activeTab], ...sliced] }));
    e.target.value = "";
  };

  const handleRemovePhoto = (id) => {
    const idx = photos[activeTab].findIndex((p) => p.id === id);
    setPhotos((prev) => ({ ...prev, [activeTab]: prev[activeTab].filter((p) => p.id !== id) }));
    setPhotoFiles((prev) => ({ ...prev, [activeTab]: prev[activeTab].filter((_, i) => i !== idx) }));
  };

  /* ── Front-end Validation ── */
  const validateForm = () => {
    const errors = {};
    if (!clientName.trim())         errors.client_name = "Client name is required.";
    if (!location.trim())           errors.location    = "Location is required.";
    if (selectedStaffIds.length === 0) errors.staff_id = "Please assign at least one staff member.";
    if (!workType)                  errors.work_type   = "Please select a work type.";
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  /* ── Submit Handler ── */
  const handleSubmit = async () => {
    setServerErrors([]);
    setFieldErrors({});

    if (!validateForm()) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const fd = new FormData();
    fd.append("client_name", clientName.trim());
    fd.append("location",    location.trim());
    fd.append("address",     address.trim());             /* NEW */

    selectedStaffIds.forEach((id) => fd.append("staff_id[]", id));

    fd.append("work_type", workType);
    fd.append("status",    jobStatus);

    activities.forEach((act, i) => {
      fd.append(`activity_type[${i}]`,     act.type);
      fd.append(`activity_user_id[${i}]`,  act.userId || selectedStaffIds[0] || "");
      fd.append(`start_time[${i}]`,        act.start);
      fd.append(`end_time[${i}]`,          act.end);
    });

    materials.forEach((mat, i) => {
      fd.append(`material_name[${i}]`,     mat.name);
      fd.append(`material_user_id[${i}]`,  mat.userId || selectedStaffIds[0] || "");
      fd.append(`quantity[${i}]`,          mat.qty);
      fd.append(`unit[${i}]`,              mat.unit || "nos");   /* NEW */
    });

    const photoTagMap = {
      "Before Work": "photos_before",
      "During Work": "photos_during",
      "After Work":  "photos_after",
    };
    Object.entries(photoFiles).forEach(([tab, files]) => {
      const key = photoTagMap[tab];
      files.forEach((file) => fd.append(`${key}[]`, file));
    });

    setSubmitting(true);
    try {
      const res = await createJob(fd);
      if (res.data.status) {
        setSubmitSuccess(true);
        setTimeout(() => navigate("/job/reports"), 1500);
      }
    } catch (err) {
      const data = err?.response?.data;
      if (data?.errors) {
        const msgs = Object.values(data.errors).flat();
        setServerErrors(msgs);
        const fe = {};
        if (data.errors.client_name) fe.client_name = data.errors.client_name[0];
        if (data.errors.location)    fe.location    = data.errors.location[0];
        if (data.errors.address)     fe.address     = data.errors.address[0];
        if (data.errors["staff_id"] || data.errors["staff_id.0"])
          fe.staff_id = (data.errors["staff_id"] || data.errors["staff_id.0"])[0];
        if (data.errors.work_type)   fe.work_type   = data.errors.work_type[0];
        if (data.errors.status)      fe.status      = data.errors.status[0];
        setFieldErrors(fe);
      } else {
        setServerErrors([data?.message || "Something went wrong. Please try again."]);
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setSubmitting(false);
    }
  };

  /* ─────────────────────── Render ─────────────────────────── */
  return (
    <>
      <style>{STYLES}</style>

      {submitting && (
        <div className="loader-overlay">
          <div className="loader-box">
            <div className="loader-spinner" />
            <div className="loader-title">Submitting Job…</div>
            <div className="loader-sub">Please wait, uploading data & photos</div>
          </div>
        </div>
      )}

      <div className="page-wrap">

        {/* Breadcrumb */}
        <div className="bc">
          <a onClick={() => navigate("/dashboard")}>Dashboard</a>
          <span>›</span>
          <span style={{ color: "#374151" }}>Create New Job</span>
        </div>

        {/* Success Banner */}
        {submitSuccess && (
          <div className="success-banner">
            <CheckIcon />
            Job created successfully! Redirecting to reports…
          </div>
        )}

        {/* Server Error Banner */}
        {serverErrors.length > 0 && (
          <div className="error-banner">
            <div className="err-title"><AlertIcon /> Please fix the following errors:</div>
            <ul>{serverErrors.map((e, i) => <li key={i}>{e}</li>)}</ul>
          </div>
        )}

        {/* Info banner */}
        <div className="vbanner">
          <AlertIcon />
          <span>
            All fields marked with <strong>*</strong> are required.&nbsp;
            End time must be after start time.&nbsp;
            Activities are only logged when job status is{" "}
            <strong>Ongoing</strong> or <strong>Revisit</strong>.
          </span>
        </div>

        <div className="two-col">

          {/* ══ LEFT — Basic Job Details ══ */}
          <div>
            <div className="card">
              <div className="card-hd"><h3>Basic Job Details</h3></div>
              <div className="card-body">

                <div className="fg">
                  <label className="fl req">Client Name</label>
                  <input
                    className={`fi${fieldErrors.client_name ? " field-err" : ""}`}
                    placeholder="Enter client name"
                    value={clientName}
                    onChange={(e) => { setClientName(e.target.value); setFieldErrors((p) => ({ ...p, client_name: "" })); }}
                  />
                  {fieldErrors.client_name && <span className="field-err-msg">{fieldErrors.client_name}</span>}
                </div>

                {/* Location + Address side-by-side */}
                <div className="form-row">
                  <div className="fg" style={{ marginBottom: 0 }}>
                    <label className="fl req">Location</label>
                    <input
                      className={`fi${fieldErrors.location ? " field-err" : ""}`}
                      placeholder="City / area"
                      value={location}
                      onChange={(e) => { setLocation(e.target.value); setFieldErrors((p) => ({ ...p, location: "" })); }}
                    />
                    {fieldErrors.location && <span className="field-err-msg">{fieldErrors.location}</span>}
                  </div>
                  <div className="fg" style={{ marginBottom: 0 }}>
                    <label className="fl">Address</label>
                    <textarea
                      className={`fi fi-textarea${fieldErrors.address ? " field-err" : ""}`}
                      placeholder="Full address (optional)"
                      value={address}
                      rows={2}
                      onChange={(e) => { setAddress(e.target.value); setFieldErrors((p) => ({ ...p, address: "" })); }}
                    />
                    {fieldErrors.address && <span className="field-err-msg">{fieldErrors.address}</span>}
                  </div>
                </div>

                {/* ── Staff Assignment ── */}
                <div className="fg" style={{ marginTop: ".85rem" }}>
                  <label className="fl req" style={{ display: "flex", alignItems: "center", gap: ".35rem" }}>
                    <UsersIcon /> Assign Staff
                  </label>

                  {isStaff ? (
                    <>
                      <div className="staff-locked">
                        <span>{loggedUser?.name || "You"}</span>
                        <span className="staff-locked-badge">You</span>
                      </div>
                      <div className="role-hint">
                        You are automatically assigned as the staff for this job.
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={`staff-picker${fieldErrors.staff_id ? " field-err" : ""}`}>
                        <div className="staff-tags">
                          {selectedStaffIds.length === 0 && (
                            <span style={{ fontSize: ".8rem", color: "#c0c4cc" }}>No staff assigned yet…</span>
                          )}
                          {selectedStaffIds.map((id) => (
                            <span className="staff-tag" key={id}>
                              {getStaffNameById(id)}
                              <button onClick={() => handleRemoveStaff(id)} title="Remove">
                                <CloseIcon />
                              </button>
                            </span>
                          ))}
                        </div>
                        <select
                          className="staff-picker-select"
                          onChange={handleAddStaff}
                          defaultValue=""
                        >
                          <option value="" disabled>+ Add staff member…</option>
                          {staffList
                            .filter((s) => !selectedStaffIds.includes(String(s.id)))
                            .map((s) => (
                              <option key={s.id} value={s.id}>{s.name}</option>
                            ))}
                        </select>
                      </div>
                      {fieldErrors.staff_id && <span className="field-err-msg">{fieldErrors.staff_id}</span>}
                      {selectedStaffIds.length > 0 && (
                        <div className="role-hint">
                          {selectedStaffIds.length} staff member{selectedStaffIds.length > 1 ? "s" : ""} assigned
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="fg">
                  <label className="fl req">Work Type</label>
                  <select
                    className={`fs${fieldErrors.work_type ? " field-err" : ""}`}
                    value={workType}
                    onChange={(e) => { setWorkType(e.target.value); setFieldErrors((p) => ({ ...p, work_type: "" })); }}
                  >
                    <option value="">— Select Work Type —</option>
                    <optgroup label="Wrapping">
                      <option>Wrapping – Direct Wrap</option>
                      <option>Wrapping – Flat &amp; Wrap</option>
                    </optgroup>
                    <optgroup label="Wrapping Articles">
                      <option>Kitchen Cabinet</option>
                      <option>Walls</option>
                      <option>Wardrobe</option>
                      <option>Single Door</option>
                      <option>Double Door</option>
                      <option>Vanity</option>
                      <option>Skirting</option>
                      <option>Backsplash</option>
                      <option>Countertop</option>
                      <option>Furniture</option>
                      <option>Lift / Escalator</option>
                      <option>Appliances</option>
                    </optgroup>
                    <optgroup label="Flooring">
                      <option>Flooring – Self Levelling</option>
                      <option>Flooring – LVT / SPC Laying</option>
                      <option>Flooring – Laying Vinyl Roll</option>
                      <option>Flooring – Carpet Laying</option>
                      <option>Flooring – Micro-Cement</option>
                      <option>Flooring – Epoxy Flooring</option>
                    </optgroup>
                    <optgroup label="Cladding Work">
                      <option>Cladding – Stone Veneer (Front Lit)</option>
                      <option>Cladding – Translucent Stone Veneer (Back Lit)</option>
                      <option>Cladding – Metal Sheet</option>
                      <option>Cladding – Soft Stone</option>
                      <option>Cladding – Aluminium Composite Panel</option>
                      <option>Cladding – Décor Panel</option>
                    </optgroup>
                    <optgroup label="Other Work Types">
                      <option>Stretch Ceiling Work</option>
                      <option>Carpentry Work</option>
                      <option>Fit Out Work</option>
                    </optgroup>
                  </select>
                  {fieldErrors.work_type && <span className="field-err-msg">{fieldErrors.work_type}</span>}
                </div>

                <div className="fg">
                  <label className="fl req">Job Status</label>
                  <select className="fs" value={jobStatus} onChange={(e) => setJobStatus(e.target.value)}>
                    <option value="ongoing">Ongoing</option>
                    <option value="pending">Pending</option>
                    <option value="hold">Hold</option>
                    <option value="completed">Completed</option>
                    <option value="revisit">Revisit</option>
                  </select>
                  <div className="status-hint">
                    Default status is <strong>Ongoing</strong>. Staff can change to Pending /
                    Ongoing / Completed.
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* ══ RIGHT — Activity + Materials + Photos ══ */}
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>

            {/* Activity Logs */}
            <div className="card">
              <div className="card-hd">
                <div>
                  <h3>Activity Logs</h3>
                  <div className="sub">Only when job is Ongoing or Revisit</div>
                </div>
              </div>
              <div className="card-body">

                <div className="fg">
                  <label className="fl">Activity Type</label>
                  <select className="fs" value={activityType}
                    onChange={(e) => setActivityType(e.target.value)}>
                    <option value="">— Select Activity Type —</option>
                    <option>Office Briefing</option>
                    <option>Material Collection / Return</option>
                    <option>Travelling</option>
                    <option>Scaffolding Erection / Dismantle</option>
                    <option>Before Photos</option>
                    <option>Alignment</option>
                    <option>Site Survey</option>
                    <option>Surface Test</option>
                    <option>Article Cleaning</option>
                    <option>Electrical</option>
                    <option>Plumbing</option>
                    <option>Carpentry</option>
                    <option>Sanding</option>
                    <option>Putty Application</option>
                    <option>Flattening</option>
                    <option>Primer Application</option>
                    <option>Self Levelling Application</option>
                    <option>Old Removing</option>
                    <option>Taking Measurement after Numbering</option>
                    <option>Material Cutting &amp; Levelling</option>
                    <option>Vinyl Wrapping</option>
                    <option>LVT / SPC Laying</option>
                    <option>Skirting Installation</option>
                    <option>Quality Checking / Snagging</option>
                    <option>De-snagging / Rectification</option>
                    <option>Silicone Application after Cleaning</option>
                    <option>Site Cleaning</option>
                    <option>After Photo</option>
                    <option>Site Delivery</option>
                    <option>Break</option>
                    <option>Purchasing</option>
                    <option>Transporting</option>
                    <option>Others (to be specified)</option>
                  </select>
                </div>

                <div className="fg">
                  <label className="fl">Performed By</label>
                  {isStaff ? (
                    <div className="staff-locked" style={{ fontSize: ".875rem" }}>
                      <span>{loggedUser?.name || "You"}</span>
                      <span className="staff-locked-badge">You</span>
                    </div>
                  ) : (
                    <select
                      className="fs"
                      value={activityUserId}
                      onChange={(e) => setActivityUserId(e.target.value)}
                      disabled={assignableUsers.length === 0}
                    >
                      <option value="">— Select staff member —</option>
                      {assignableUsers.map((u) => (
                        <option key={u.id} value={u.id}>{u.name}</option>
                      ))}
                    </select>
                  )}
                  {!isStaff && assignableUsers.length === 0 && (
                    <span className="form-help" style={{ color: "#f59e0b" }}>
                      Assign staff above to enable this dropdown
                    </span>
                  )}
                </div>

                <div className="form-row">
                  <div className="fg" style={{ marginBottom: 0 }}>
                    <label className="fl">Start Time</label>
                    <input className="fi" type="time" value={startTime}
                      onChange={(e) => setStartTime(e.target.value)} />
                  </div>
                  <div className="fg" style={{ marginBottom: 0 }}>
                    <label className="fl">End Time</label>
                    <input className="fi" type="time" value={endTime}
                      onChange={(e) => setEndTime(e.target.value)} />
                    <div className="form-help">End must be after start</div>
                  </div>
                </div>

                {activityError && (
                  <div style={{ color: "#dc2626", fontSize: ".75rem", margin: ".3rem 0 .5rem" }}>
                    {activityError}
                  </div>
                )}

                {activities.length > 0 && <hr className="divider" />}

                {activities.map((act, i) => {
                  const dur = calcDuration(act.start, act.end);
                  return (
                    <div className="act-entry" key={i}>
                      <div>
                        <div className="act-name">{act.type}</div>
                        <div className="act-meta">
                          {getStaffNameById(act.userId) || "—"} · {act.start} – {act.end}
                        </div>
                      </div>
                      <div className="act-right">
                        <span className="badge-min">{dur} min</span>
                        <button className="btn-icon" title="Edit" onClick={() => handleEditActivity(i)}>
                          <EditIcon />
                        </button>
                        <button className="btn-icon del" title="Delete" onClick={() => handleDeleteActivity(i)}>
                          <TrashIcon />
                        </button>
                      </div>
                    </div>
                  );
                })}

                <button className="btn-outline-sm" onClick={handleAddActivity}>
                  + {editIndex !== null ? "Update Activity" : "Add Activity"}
                </button>

              </div>
            </div>

            {/* Materials Used */}
            <div className="card">
              <div className="card-hd"><h3>Materials Used</h3></div>
              <div className="card-body">

                {materials.map((mat) => (
                  <div key={mat.id} style={{
                    marginBottom: ".75rem", background: "#f9fafb",
                    border: "1.5px solid #e5e7eb", borderRadius: "10px", padding: ".7rem .85rem"
                  }}>
                    {/* Row 1: material name + qty + unit + delete */}
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 72px 86px 36px",   /* name | qty | unit | del */
                      gap: ".5rem", alignItems: "center", marginBottom: ".5rem"
                    }}>
                      {/* Material name */}
                      <select className="fs" value={mat.name}
                        style={{ background: "#fff" }}
                        onChange={(e) => handleMaterialChange(mat.id, "name", e.target.value)}>
                        {MATERIAL_OPTIONS.map((o) => <option key={o}>{o}</option>)}
                      </select>

                      {/* Quantity */}
                      <input className="fi" type="number" min={1} value={mat.qty}
                        style={{ textAlign: "center", background: "#fff" }}
                        onChange={(e) => handleMaterialChange(mat.id, "qty", e.target.value)} />

                      {/* Unit dropdown — NEW */}
                      <select className="fs" value={mat.unit}
                        style={{ background: "#fff", paddingRight: "1.6rem" }}
                        onChange={(e) => handleMaterialChange(mat.id, "unit", e.target.value)}>
                        {UNIT_OPTIONS.map((u) => (
                          <option key={u} value={u}>{u.toUpperCase()}</option>
                        ))}
                      </select>

                      {/* Delete */}
                      <button className="btn-icon del"
                        style={{ width: 36, height: 38, borderRadius: 8 }}
                        title="Remove" onClick={() => handleDeleteMaterial(mat.id)}>
                        <TrashIcon />
                      </button>
                    </div>

                    {/* Row 2: used by */}
                    <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
                      <label style={{
                        fontSize: ".68rem", fontWeight: 700, letterSpacing: ".06em",
                        textTransform: "uppercase", color: "#6b7280", whiteSpace: "nowrap"
                      }}>
                        Used By
                      </label>
                      {isStaff ? (
                        <div className="staff-locked" style={{ flex: 1, fontSize: ".8rem", padding: ".35rem .7rem" }}>
                          <span>{loggedUser?.name || "You"}</span>
                          <span className="staff-locked-badge">You</span>
                        </div>
                      ) : (
                        <select
                          className="fs"
                          style={{ flex: 1, fontSize: ".8rem", padding: ".35rem .7rem", background: "#fff" }}
                          value={mat.userId}
                          onChange={(e) => handleMaterialChange(mat.id, "userId", e.target.value)}
                          disabled={assignableUsers.length === 0}
                        >
                          <option value="">— Select staff —</option>
                          {assignableUsers.map((u) => (
                            <option key={u.id} value={u.id}>{u.name}</option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>
                ))}

                {!isStaff && assignableUsers.length === 0 && materials.length > 0 && (
                  <div className="form-help" style={{ color: "#f59e0b", marginBottom: ".5rem" }}>
                    Assign staff above to enable "Used By" dropdowns
                  </div>
                )}

                <button className="btn-outline-sm" onClick={handleAddMaterial}>
                  + Add Material
                </button>

              </div>
            </div>

            {/* Upload Photos */}
            <div className="card">
              <div className="card-hd">
                <h3>Upload Photos</h3>
                <span className="photo-counter">{currentPhotos.length} / {MAX_PHOTOS}</span>
              </div>
              <div className="card-body">
                <div className="photo-tabs">
                  {PHOTO_TABS.map((tab) => (
                    <button key={tab}
                      className={`photo-tab${activeTab === tab ? " active" : ""}`}
                      onClick={() => setActiveTab(tab)}>
                      {tab}
                    </button>
                  ))}
                </div>
                {currentPhotos.length > 0 && (
                  <div className="photo-grid">
                    {currentPhotos.map((p) => (
                      <div className="photo-thumb" key={p.id}>
                        <img src={p.url} alt={p.name} />
                        <button className="photo-remove" onClick={() => handleRemovePhoto(p.id)}>✕</button>
                      </div>
                    ))}
                  </div>
                )}
                {currentPhotos.length < MAX_PHOTOS && (
                  <div className="drop-zone" onClick={() => fileInputRef.current?.click()}>
                    <ImageIcon />
                    <div className="drop-zone-title">Tap to upload photos</div>
                    <div className="drop-zone-sub">
                      Camera or gallery · Max {MAX_PHOTOS} photos per job
                    </div>
                  </div>
                )}
                <input ref={fileInputRef} type="file" accept="image/*"
                  capture="environment" multiple style={{ display: "none" }}
                  onChange={handlePhotoUpload} />
              </div>
            </div>

          </div>
        </div>

        {/* Footer */}
        <div className="form-footer">
          <button className="btn-ghost" disabled={submitting}>Save as Draft</button>
          <div style={{ display: "flex", gap: ".5rem" }}>
            <button className="btn-export" disabled={submitting}>
              <ExportIcon /> Export PDF
            </button>
            <button className="btn-submit" onClick={handleSubmit} disabled={submitting || submitSuccess}>
              {submitting ? <><SpinnerIcon /> Submitting…</> : <><CheckIcon /> Submit Job</>}
            </button>
          </div>
        </div>

      </div>
    </>
  );
}

export default CreateJobForm;